import React from "react";
import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";
import { NewTable } from "../../../news/components/NewTable/NewTable";
import { useNewsTab } from "./useNewsTab";

export const NewsTab: React.FC = () => {
  const { newsResource } = useNewsTab();

  return (
    <ResourceTab
      resource={{
        data: newsResource.data,
        isLoading: newsResource.isLoading,
        isError: newsResource.isError,
        page: newsResource.page,
        pageSize: newsResource.pageSize,
        handlePageChange: newsResource.handlePageChange,
        handlePageSizeChange: newsResource.handlePageSizeChange,
      }}
      filtersComponent={null}
      tableComponent={
        <NewTable
          news={newsResource.data!}
          isLoading={newsResource.isLoading}
          isError={newsResource.isError}
          page={newsResource.page}
          pageSize={newsResource.pageSize}
          onPageChange={newsResource.handlePageChange}
          onPageSizeChange={newsResource.handlePageSizeChange}
        />
      }
      emptyStateMessage="No hay novedades para mostrar."
    />
  );
};

